import * as i0 from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
let FormatFileNamePipe = /*#__PURE__*/(() => {
  class FormatFileNamePipe {
    constructor() {
      this._maxNameLength = 50;
    }
    transform(value, ...args) {
      const nameArr = value.split('.');
      const format = nameArr.pop();
      const name = nameArr.join('.');
      if (name.length > this._maxNameLength) {
        const middle = this._maxNameLength / 2;
        const croppedName = FormatFileNamePipe._cutMiddle(name, middle, name.length - middle);
        const formattedName = FormatFileNamePipe._replaceChar(croppedName, middle, 0, '...');
        return formattedName + '.' + format;
      } else {
        return value;
      }
    }
    static _replaceChar(str, idx, rem, value) {
      return str.slice(0, idx) + value + str.slice(idx + Math.abs(rem));
    }
    static _cutMiddle(str, cutStart, cutEnd) {
      return str.substr(0, cutStart) + str.substr(cutEnd + 1);
    }
    static {
      this.ɵfac = function FormatFileNamePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormatFileNamePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formatFileName",
        type: FormatFileNamePipe,
        pure: true
      });
    }
  }
  return FormatFileNamePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrderByPipe = /*#__PURE__*/(() => {
  class OrderByPipe {
    transform(array, field) {
      array.sort((a, b) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
      return array;
    }
    static {
      this.ɵfac = function OrderByPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrderByPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "orderBy",
        type: OrderByPipe,
        pure: true
      });
    }
  }
  return OrderByPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReplacePipe = /*#__PURE__*/(() => {
  class ReplacePipe {
    transform(value, search, replace) {
      return value.split(search).join(replace);
    }
    static {
      this.ɵfac = function ReplacePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReplacePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "replace",
        type: ReplacePipe,
        pure: true
      });
    }
  }
  return ReplacePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor() {
      this._sanitizer = inject(DomSanitizer);
    }
    transform(value, type) {
      switch (type) {
        case 'html':
          return this._sanitizer.bypassSecurityTrustHtml(value) || '';
        case 'style':
          return this._sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this._sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this._sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this._sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
    static {
      this.ɵfac = function SafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TypeofPipe = /*#__PURE__*/(() => {
  class TypeofPipe {
    transform(value, type) {
      if (type) {
        return typeof value === type;
      } else {
        return typeof value;
      }
    }
    static {
      this.ɵfac = function TypeofPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TypeofPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "typeof",
        type: TypeofPipe,
        pure: true
      });
    }
  }
  return TypeofPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SplitPipe = /*#__PURE__*/(() => {
  class SplitPipe {
    transform(input, separator = ' ', limit) {
      if (typeof input !== 'string') {
        return input;
      }
      return input.split(separator, limit);
    }
    static {
      this.ɵfac = function SplitPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "split",
        type: SplitPipe,
        pure: true
      });
    }
  }
  return SplitPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JoinPipe = /*#__PURE__*/(() => {
  class JoinPipe {
    transform(input, sep = ', ') {
      return input.join(sep);
    }
    static {
      this.ɵfac = function JoinPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || JoinPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "join",
        type: JoinPipe,
        pure: true
      });
    }
  }
  return JoinPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgnoreHtmlTagsPipe = /*#__PURE__*/(() => {
  class IgnoreHtmlTagsPipe {
    constructor() {}
    transform(value) {
      return value.replace(/<([^^]*?)>/gi, '');
    }
    static {
      this.ɵfac = function IgnoreHtmlTagsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgnoreHtmlTagsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "ignoreHtmlTags",
        type: IgnoreHtmlTagsPipe,
        pure: true
      });
    }
  }
  return IgnoreHtmlTagsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CryptoAddressPipe = /*#__PURE__*/(() => {
  class CryptoAddressPipe {
    transform(value) {
      if (!value) {
        return '';
      }
      return value.replace('bitcoincash:', '');
    }
    static {
      this.ɵfac = function CryptoAddressPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CryptoAddressPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cryptoAddress",
        type: CryptoAddressPipe,
        pure: true
      });
    }
  }
  return CryptoAddressPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Resolve correct format for currencies
 */
let CyptoProtocolFormatPipe = /*#__PURE__*/(() => {
  class CyptoProtocolFormatPipe {
    constructor() {
      this._cryptoProtocolMap = {
        TRON: 'TRC20'
      };
    }
    transform(value) {
      return this._cryptoProtocolMap[value] || value;
    }
    static {
      this.ɵfac = function CyptoProtocolFormatPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CyptoProtocolFormatPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cyptoProtocolFormat",
        type: CyptoProtocolFormatPipe,
        pure: true
      });
    }
  }
  return CyptoProtocolFormatPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KeysCountPipe = /*#__PURE__*/(() => {
  class KeysCountPipe {
    transform(value) {
      if (!value || typeof value !== 'object') {
        return 0;
      }
      return Object.keys(value).length;
    }
    static {
      this.ɵfac = function KeysCountPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KeysCountPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "keysCount",
        type: KeysCountPipe,
        pure: true
      });
    }
  }
  return KeysCountPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NormalizeKeyPipe = /*#__PURE__*/(() => {
  class NormalizeKeyPipe {
    transform(value) {
      return value.replace(/_+\d+$/, '');
    }
    static {
      this.ɵfac = function NormalizeKeyPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NormalizeKeyPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "normalizeKey",
        type: NormalizeKeyPipe,
        pure: true
      });
    }
  }
  return NormalizeKeyPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReplaceLineBreaksPipe = /*#__PURE__*/(() => {
  class ReplaceLineBreaksPipe {
    transform(value) {
      if (value === null || typeof value !== 'string') {
        return value;
      }
      return value.replace(/<br\s*\/?>/gi, '');
    }
    static {
      this.ɵfac = function ReplaceLineBreaksPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReplaceLineBreaksPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "replaceLineBreaks",
        type: ReplaceLineBreaksPipe,
        pure: true
      });
    }
  }
  return ReplaceLineBreaksPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReversePipe = /*#__PURE__*/(() => {
  class ReversePipe {
    transform(value) {
      return value.slice().reverse();
    }
    static {
      this.ɵfac = function ReversePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReversePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "reverse",
        type: ReversePipe,
        pure: true
      });
    }
  }
  return ReversePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShortEmailPipe = /*#__PURE__*/(() => {
  class ShortEmailPipe {
    /**
     * From:
     *  super.long.email297@gmail.com
     * To:
     *  sup...@gmail.com
     *
     * @param value
     */
    transform(value) {
      if (!value.includes('@')) {
        return value;
      }
      const parts = value.split('@');
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].substring(0, 3);
      }
      return `${parts[0]}...@${parts[1]}`;
    }
    static {
      this.ɵfac = function ShortEmailPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ShortEmailPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "shortEmail",
        type: ShortEmailPipe,
        pure: true
      });
    }
  }
  return ShortEmailPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StripHtmlPipe = /*#__PURE__*/(() => {
  class StripHtmlPipe {
    transform(value, tags = /<.*?>/g) {
      return value?.replace(tags, ''); // replace tags
    }
    static {
      this.ɵfac = function StripHtmlPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StripHtmlPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "striphtml",
        type: StripHtmlPipe,
        pure: true
      });
    }
  }
  return StripHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CryptoAddressPipe, CyptoProtocolFormatPipe, FormatFileNamePipe, IgnoreHtmlTagsPipe, JoinPipe, KeysCountPipe, NormalizeKeyPipe, OrderByPipe, ReplaceLineBreaksPipe, ReplacePipe, ReversePipe, SafePipe, ShortEmailPipe, SplitPipe, StripHtmlPipe, TypeofPipe };
